export const managerUsers = {
  usersList: {
    title: "Usuarios registrados",
    subtitle: "Listado de usuarios registrados en la plataforma.",
    columns: {
      id: "ID",
      name: "Nombre",
      phone: "Teléfono",
      email: "Email",
      accommodations: "Alojamientos",
      sends: "Envíos",
      checkin: "Check-in",
      registeredAt: "Fecha de registro",
    },
    states: {
      demo: "Versión demo",
      demoEnded: "Demo terminada",
      subscribed: "Usuario suscrito",
      subscriptionExpired: "Suscripción vencida",
      queryError: "Error en la consulta",
    },
    deleteAdvisor: {
      confirmMessage: "¿Estas seguro de eliminar el asesor?",
      confirmHeader: "Confirmar",
    },
  },
  accommodationUser: {
    info: "Información del alojamiento",
  },
  dataUserOld: {
    accommodationsList: "Listado de alojamientos",
    createAccommodation: "Crear alojamiento",
    emptyMessage: "No hay alojamientos registrados",
    emptySubMessage: "Aquí aparecerán los alojamientos registrados por el usuario",
  },
  checkins: {
    title: "Check-ins realizados",
  },
  checkinsPending: {
    title: "Check-ins pendientes o en proceso",
  },
};
